import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import HeaderLogin from "../../Components/HeaderLogin/HeaderLogin";
import "./LoginPage.css";
import Footer from "../../Components/Footer/Footer";
import axios from "axios"
import Alert from "@mui/material/Alert";

const LoginPage = ({ setUserLoggedIn }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const [otpStep, setOtpStep] = useState(false);
  const [otp, setOtp] = useState("");
  const [adminEmail, setAdminEmail] = useState("");
  const [adminPassword, setAdminPassword] = useState("");
  const [otpError, setOtpError] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [otpTimer, setOtpTimer] = useState(2 * 60);
  const [otpExpired, setOtpExpired] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    setError(false);
    const loginData = {
      email: username,
      password: password,
    };
    const headers = {
      "Content-Type": "application/json",
    };
    axios
      .post("https://api.aeroprime.in/crm-service/user/login", loginData, {
        headers,
      })
      .then((response) => {
        if (response.data.otpRequired === "true") {
          setAdminEmail(response.data.email || username);
          setAdminPassword(password);
          setOtpStep(true);
        } else {
          setUserLoggedIn(true);
          localStorage.setItem("AuthToken", `Bearer ${response.data.token}`);
          localStorage.setItem("loggedin", `true`);
        }
      })
      .catch((error) => {
        setError(true);
      });
  };

  const handleOtpSubmit = (event) => {
    event.preventDefault();
    setOtpError(false);
    setOtpLoading(true);
    const headers = { "Content-Type": "application/json" };
    axios
      .post(
        "https://api.aeroprime.in/crm-service/user/login",
        { email: adminEmail, password: adminPassword, otp: otp },
        { headers }
      )
      .then((response) => {
        setUserLoggedIn(true);
        localStorage.setItem("AuthToken", `Bearer ${response.data.token}`);
        localStorage.setItem("loggedin", `true`);
        if (response.data.tokenExpiry) {
          localStorage.setItem("sessionExpiry", response.data.tokenExpiry);
        }
      })
      .catch(() => {
        setOtpError(true);
      })
      .finally(() => {
        setOtpLoading(false);
      });
  };

  useEffect(() => {
    if (!otpStep) return;
    setOtpTimer(2 * 60);
    setOtpExpired(false);
    const interval = setInterval(() => {
      setOtpTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setOtpExpired(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [otpStep]);

  const formatOtpTime = (seconds) => {
    const m = Math.floor(seconds / 60).toString().padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

  const handleKeyDown = (e) => {
    if (e.keyCode === 'Enter') {
      if (otpStep) {
        handleOtpSubmit(e);
      } else {
        handleSubmit(e);
      }
    }
  }

  useEffect(() => {
    const formElement = document.querySelector('.login-form');
    formElement.addEventListener('keydown', handleKeyDown);

    return () => {
      formElement.removeEventListener('keydown', handleKeyDown);
    };
  }, [otpStep, otp, adminEmail]);

  return (
    <>
      <HeaderLogin />
      <div className="login-form-container">
        <h1 className="login-title">LOGIN WITH YOUR TRAVEL AGENT ACCOUNT</h1>
        <div className="break-line"></div>

        {!otpStep ? (
          <form onSubmit={handleSubmit} className="login-form">
            <input
              type="text"
              className="login-Username"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              placeholder="User Name"
            />

            <input
              type="password"
              className="login-Password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="Password"
            />

            <button type="submit" className="login-button" onClick={handleSubmit}>
              LOGIN
            </button>
            {error && (
              <div className="login-sections-error">
                <Alert severity="error">
                  Login Failed! Please Try with correct username and password!
                </Alert>
              </div>
            )}
          </form>
        ) : (
          <form onSubmit={handleOtpSubmit} className="login-form">
            <div className="otp-info">
              <p className="otp-info-text">
                An OTP has been sent to the registered email address. Please enter it below to continue.
              </p>
            </div>

            <div className={`otp-timer${otpExpired ? " otp-timer--expired" : ""}`}>
              <span className="otp-timer-icon">&#9200;</span>
              {otpExpired
                ? "OTP expired. Please go back and login again."
                : <>OTP expires in <strong>{formatOtpTime(otpTimer)}</strong></>
              }
            </div>

            <input
              type="text"
              className="login-Username otp-input"
              value={otp}
              onChange={(event) => setOtp(event.target.value)}
              placeholder="Enter OTP"
              maxLength={6}
              autoFocus
              disabled={otpExpired}
            />

            <button
              type="submit"
              className="login-button"
              onClick={handleOtpSubmit}
              disabled={otpLoading || otpExpired}
            >
              {otpLoading ? "VERIFYING..." : "VERIFY OTP"}
            </button>

            <button
              type="button"
              className="otp-back-button"
              onClick={() => { setOtpStep(false); setOtp(""); setOtpError(false); setAdminPassword(""); setOtpExpired(false); }}
            >
              Back to Login
            </button>

            {otpError && (
              <div className="login-sections-error">
                <Alert severity="error">
                  Invalid or expired OTP. Please try again.
                </Alert>
              </div>
            )}
          </form>
        )}
      </div>
    </>
  );
}

export default LoginPage;
